module.exports = __webpack_public_path__ + "static/img/newsBanner.574d518.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newsBanner.png
// module id = JJ7G
// module chunks = 2